import { NgModule } from '@angular/core';

import { provideTransloco, TranslocoModule } from '@jsverse/transloco';

import { environment } from '../../../environments/environment';
import { TranslocoHttpLoader } from './transloco-http-loader/http-loader.service';


@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: 'en',
        fallbackLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production
      },
      loader: TranslocoHttpLoader
    })
  ]
})
export class TranslocoRootModule {}
